import { checkRequired, Validator } from './base';

export const validate = (data) => {
  return new Validator(
    {'name': [checkRequired,]},
    data
  ).validate()
};
